import { TextLinkWidget } from '@tableau/widgets';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { Messages } from '~src/codegen/Localize';
import { HelpService } from '~src/commonInfra/services/HelpService';
import { MapDispatchToProps } from '~src/commonInfra/utils/ConnectUtils';

import { learnMoreStyle,SettingsStyles } from '../styles/CommonStyles';
import { fetchPrivateConnectionsRequest } from './actions/FetchPrivateConnectionsRequestAction';
import { ConnectedPrivateConnectionTable } from './components/PrivateConnectionTable';
import { privateConnectSettingsContainer, privateConnectSpaceContainer } from './styles/PrivateConnectSettingsStyles';


interface PrivateConnectSiteSettingsSubspaceOwnProps {
  readonly isSessionServerAdmin: boolean;
  readonly isOnlineEnvironment: boolean;
}

export interface PrivateConnectSiteSettingsSubspaceDispatchProps {
  requestPrivateConnectionsInfo: () => void;
}

export type PrivateConnectSiteSettingsSubspaceProps = PrivateConnectSiteSettingsSubspaceOwnProps & PrivateConnectSiteSettingsSubspaceDispatchProps;

export interface PrivateConnectSiteSettingsSubspaceState {
  isLoading: boolean;
  readonly hasError: boolean;
}

export class PrivateConnectSiteSettingsSubspaceComponent extends React.PureComponent<PrivateConnectSiteSettingsSubspaceProps, PrivateConnectSiteSettingsSubspaceState> {
  private unmounted: boolean = false;


  private initialState: PrivateConnectSiteSettingsSubspaceState = {
    isLoading: true,
    hasError: false
  };


  public constructor(props: PrivateConnectSiteSettingsSubspaceProps) {
    super(props);
    this.state = this.initialState;
  }

  public componentWillUnmount() {
    this.unmounted = true;
  }

  public componentDidMount(): void {
    if (this.props.isOnlineEnvironment) {
      this.props.requestPrivateConnectionsInfo();
    }
  }

  public render() {
    if (!this.props.isOnlineEnvironment) {
      return null;
    }

    return (
      <div className={privateConnectSpaceContainer}>
        <div className={privateConnectSettingsContainer}>
          <div className={SettingsStyles.settingsGroupName}>
            {Messages.privateconnect()}
          </div>
          <div style={{width: '700px'}}>
            {Messages.privateConnect_description_label()}
            &nbsp;
            <TextLinkWidget
              testId={'private-connect-learn-more'}
              target={'_blank'}
              href={HelpService.getHelpUrlByCategory('online-settings-private-connect')}
              className={learnMoreStyle}>
              {Messages.learnMore()}
            </TextLinkWidget>
          </div>
        </div>
        <div className={privateConnectSettingsContainer}>
          <ConnectedPrivateConnectionTable/>
        </div>
      </div>
    );
  }
}


const mapDispatchToProps: MapDispatchToProps<PrivateConnectSiteSettingsSubspaceDispatchProps> =
  (dispatch) => bindActionCreators({
    requestPrivateConnectionsInfo: fetchPrivateConnectionsRequest
  },
  dispatch);

export const PrivateConnectSiteSettingsSubspace: React.ComponentClass<PrivateConnectSiteSettingsSubspaceOwnProps> =
  connect(undefined, mapDispatchToProps)(PrivateConnectSiteSettingsSubspaceComponent);